import React from 'react';
import '../styles/Gallery.css';
import img1 from '../otherIMG/img1.jpg';
import img2 from '../otherIMG/img2.jpg';
import img3 from '../otherIMG/img3.jpg';
import img4 from '../otherIMG/img4.jpg';
import img5 from '../otherIMG/img5.jpg';
import img6 from '../otherIMG/img6.jpg';
import img7 from '../otherIMG/img7.jpg';
import img8 from '../otherIMG/img8.jpg';
import img9 from '../otherIMG/img9.jpg';
import img10 from '../otherIMG/img10.jpg';
import img11 from '../otherIMG/img11.jpg';
import img12 from '../otherIMG/img12.jpg';
import img13 from '../otherIMG/img13.jpg';
import img14 from '../otherIMG/img14.jpg';
import img15 from '../otherIMG/img15.jpg';
import img16 from '../otherIMG/img16.jpg';
import img17 from '../otherIMG/img17.jpg';
import img18 from '../otherIMG/img18.jpg';
import img19 from '../otherIMG/img19.jpg';
import img20 from '../otherIMG/img20.jpg';
import img21 from '../otherIMG/img21.jpg';
import img22 from '../otherIMG/img22.jpg';
import img23 from '../otherIMG/img23.jpg';
import img24 from '../otherIMG/img24.jpg';
import img25 from '../otherIMG/img25.jpg';
import img26 from '../otherIMG/img26.jpg';
import img27 from '../otherIMG/img27.jpg';
import img28 from '../otherIMG/img28.jpg';
import img29 from '../otherIMG/img29.jpg';
import img30 from '../otherIMG/img30.jpg';
import img31 from '../otherIMG/img31.jpg';
import img32 from '../otherIMG/img32.jpg';
import img33 from '../otherIMG/img33.jpg';
import img34 from '../otherIMG/img34.jpg';
import img35 from '../otherIMG/img35.jpg';
import img36 from '../otherIMG/img36.jpg';
import img37 from '../otherIMG/img37.jpg';
import img38 from '../otherIMG/img38.jpg';
import img39 from '../otherIMG/img39.jpg';
import img40 from '../otherIMG/img40.jpg';
import img41 from '../otherIMG/img41.jpg';
import img42 from '../otherIMG/img42.jpg';
import img43 from '../otherIMG/img43.jpg';




function Gallery() {
  return (
    <div id='galleryBody'>
      <div className='carouselContainer'>
        <div className='column'>
          <div className='imgHolder'>
            <img src={img27} alt='img27'/>
          </div>
          <div className='imgHolder'>
            <img src={img2} alt='img2'/>
          </div>
          <div className='imgHolder'>
            <img src={img3} alt='img3'/>
          </div>
          <div className='imgHolder'>
            <img src={img4} alt='img4'/>
          </div>
          <div className='imgHolder'>
            <img src={img5} alt='img5'/>
          </div>
          <div className='imgHolder'>
            <img src={img6} alt='img6'/>
          </div>
          <div className='imgHolder'>
            <img src={img7} alt='img7'/>
          </div>
          <div className='imgHolder'>
            <img src={img8} alt='img8'/>
          </div>
          <div className='imgHolder'>
            <img src={img33} alt='img33'/>
          </div>
          <div className='imgHolder'>
            <img src={img34} alt='img34'/>
          </div>
          <div className='imgHolder'>
            <img src={img35} alt='img35'/>
          </div>
        </div>
      </div>
      <div className='carouselContainer2'>
        <div className='column'>
          <div className='imgHolder'>
            <img src={img9} alt='img9'/>
          </div>
          <div className='imgHolder'>
            <img src={img10} alt='img10'/>
          </div>
          <div className='imgHolder'>
            <img src={img11} alt='img11'/>
          </div>
          <div className='imgHolder'>
            <img src={img12} alt='img12'/>
          </div>
          <div className='imgHolder'>
            <img src={img13} alt='img13'/>
          </div>
          <div className='imgHolder'>
            <img src={img14} alt='img14'/>
          </div>
          <div className='imgHolder'>
            <img src={img15} alt='img15'/>
          </div>
          <div className='imgHolder'>
            <img src={img16} alt='img16'/>
          </div>
          <div className='imgHolder'>
            <img src={img36} alt='img36'/>
          </div>
          <div className='imgHolder'>
            <img src={img37} alt='img37'/>
          </div>
          <div className='imgHolder'>
            <img src={img37} alt='img37'/>
          </div>
        </div>
      </div>
      <div className='carouselContainer3'>
        <div className='column'>
          <div className='imgHolder'>
            <img src={img17} alt='img17'/>
          </div>
          <div className='imgHolder'>
            <img src={img18} alt='img18'/>
          </div>
          <div className='imgHolder'>
            <img src={img19} alt='img19'/>
          </div>
          <div className='imgHolder'>
            <img src={img20} alt='img20'/>
          </div>
          <div className='imgHolder'>
            <img src={img21} alt='img21'/>
          </div>
          <div className='imgHolder'>
            <img src={img22} alt='img22'/>
          </div>
          <div className='imgHolder'>
            <img src={img23} alt='img23'/>
          </div>
          <div className='imgHolder'>
            <img src={img24} alt='img24'/>
          </div>
          <div className='imgHolder'>
            <img src={img38} alt='img38'/>
          </div>
          <div className='imgHolder'>
            <img src={img39} alt='img39'/>
          </div>
          <div className='imgHolder'>
            <img src={img40} alt='img40'/>
          </div>
        </div>
      </div>
      <div className='carouselContainer4'>
        <div className='column'>
          <div className='imgHolder'>
            <img src={img25} alt='img25'/>
          </div>
          <div className='imgHolder'>
            <img src={img26} alt='img26'/>
          </div>
          <div className='imgHolder'>
            <img src={img27} alt='img27'/>
          </div>
          <div className='imgHolder'>
            <img src={img28} alt='img28'/>
          </div>
          <div className='imgHolder'>
            <img src={img29} alt='img29'/>
          </div>
          <div className='imgHolder'>
            <img src={img30} alt='img30'/>
          </div>
          <div className='imgHolder'>
            <img src={img31} alt='img31'/>
          </div>
          <div className='imgHolder'>
            <img src={img32} alt='img32'/>
          </div>
          <div className='imgHolder'>
            <img src={img41} alt='img41'/>
          </div>
          <div className='imgHolder'>
            <img src={img42} alt='img42'/>
          </div>
          <div className='imgHolder'>
            <img src={img43} alt='img43'/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
